import React, { lazy } from 'react'
import { FormattedMessage } from 'react-intl'
import { Redirect } from 'react-router-dom'

// Breadcrumb components
import OrderBreadcrumb from '../components/OrderBreadcrumb'
import EditAddressBreadcrumb from '../components/EditAddressBreadcrumb'

// Lazy screens 😅
const ManageOrder = lazy(() =>
  import('screens/Yearbook/screens/ManageOrder')
)
const Yearbook = lazy(() => import('screens/Yearbook'))
const YearbookLayout = lazy(() => import('layouts/YearbookLayout'))
const EditAddress = lazy(() =>
  import('screens/Yearbook/screens/ManageOrder/screens/EditAddress')
)
const EditDeliveryDate = lazy(() =>
  import(
    'screens/Yearbook/screens/ManageOrder/screens/EditDeliveryDate'
  )
)
// const EditSpecs = lazy(() =>
//   import('screens/Yearbook/screens/ManageOrder/screens/EditSpecs')
// )
const PrintData = lazy(() =>
  import('screens/Yearbook/screens/PrintData')
)
const DataUpload = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/DataUpload')
)
const Status = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/Status')
)
const DataCheck = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/DataCheck')
)
const Approval = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/Approval')
)
const FinalCheck = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/FinalCheck')
)
const Congratulations = lazy(() =>
  import('screens/Yearbook/screens/PrintData/screens/Congratulations')
)
const ConfirmDeliveryAddress = lazy(() =>
  import(
    'screens/Yearbook/screens/PrintData/screens/ConfirmDeliveryAddress'
  )
)
const Help = lazy(() => import('screens/Help'))

const ROUTES = [
  {
    path: '/',
    component: () => <Redirect to='/yearbook' />,
    exact: true,
    breadcrumb: null
  },
  {
    path: '/yearbook',
    component: Yearbook,
    exact: true,
    breadcrumb: (
      <FormattedMessage
        id='Breadcrumbs.overview.orders'
        defaultMessage='Overview orders'
      />
    )
  },
  {
    path: '/yearbook/:id',
    component: YearbookLayout,
    breadcrumb: null,
    routes: [
      {
        path: '/yearbook/:id/manage-order',
        component: ManageOrder,
        exact: true,
        breadcrumb: OrderBreadcrumb
      },
      {
        path:
          '/yearbook/:id/manage-order/:address(delivery-address|invoice-address)',
        component: EditAddress,
        breadcrumb: EditAddressBreadcrumb,
        exact: true
      },
      {
        path: '/yearbook/:id/manage-order/delivery-date',
        component: EditDeliveryDate,
        breadcrumb: (
          <FormattedMessage
            id='Breadcrumbs.edit.delivery.date'
            defaultMessage='Edit delivery date'
          />
        ),
        exact: true
      },
      // {
      //   path: '/yearbook/:id/manage-order/edit-specs',
      //   component: EditSpecs,
      //   breadcrumb: 'Edit yearbook specifications',
      //   exact: true
      // },
      {
        path: '/yearbook/:id/print-data',
        component: PrintData,
        exact: true,
        breadcrumb: OrderBreadcrumb
      },
      {
        path: '/yearbook/:id/print-data/approval',
        component: Approval,
        exact: true
      },
      {
        path:
          '/yearbook/:id/print-data/:uploadType(final-data|proof-copy)/confirm-delivery-address',
        component: ConfirmDeliveryAddress,
        exact: true,
        breadcrumb: (
          <FormattedMessage id='Breadcrumbs.confirm.delivery.address' />
        )
      },
      {
        path:
          '/yearbook/:id/print-data/:uploadType(final-data|proof-copy)',
        component: DataUpload,
        exact: true,
        breadcrumb: ({
          match: {
            params: { uploadType }
          }
        }) => (
          <FormattedMessage id={`Breadcrumbs.upload.${uploadType}`} />
        )
      },
      {
        path: '/yearbook/:id/print-data/status',
        component: Status,
        exact: true,
        breadcrumb: (
          <FormattedMessage id='PrintData.upload.title.thanks' />
        )
      },
      {
        path: '/yearbook/:id/print-data/data-check',
        component: DataCheck,
        exact: true,
        breadcrumb: null
      },
      {
        path: '/yearbook/:id/print-data/final-check',
        component: FinalCheck,
        exact: true
      },
      {
        path: '/yearbook/:id/print-data/congratulations',
        component: Congratulations,
        exact: true
      }
    ]
  },
  {
    path: '/help',
    component: Help
  }
]

export default ROUTES



// WEBPACK FOOTER //
// ./src/components/Routes/config/routes.js